export const SENDER_GROUPS = {
	DEMO_SIGN_UP: 'eXYxPm',
	BROCHURE_DOWNLOADS: 'ep9Ygr',
	CHECKLIST_DOWNLOADS: 'enG5ZD',
	VIRTUAL_DEMO_SIGN_UPS: 'eg7J5l',
	TRIAL_SIGN_UPS: 'eg7J59',
	INTERESTED_LEADS: 'bWw5QQ',
	TEST_GROUP: 'dPQq24',
};
